import { useFormContext } from 'react-hook-form';
import { SetValueConfig } from 'react-hook-form/dist/types/form';
import { z } from 'zod';

export function useFormFieldParams<T = any>(args: UseFormParamsArgs) {
  const { name } = args;
  const { register, formState, schema, watch, setValue: setFormValue } = useFormContext();

  const isRequired = !schema?.shape?.[name]?.isOptional();
  const isBoolean = schema?.shape?.[name] instanceof z.ZodBoolean;
  const isReadonly = schema?.shape?.[name] instanceof z.ZodReadonly;
  const isArray = schema?.shape?.[name] instanceof z.ZodArray;

  const inputProps = (isBoolean)
    ? register(name, { setValueAs: (val) => (val === true || val === 'true') })
    : register(name);

  const error = formState.errors[name];
  const currentValue: T = watch()[name];

  const setValue = (value: T, opts?: SetValueConfig) => setFormValue(name, value, opts);

  return {
    inputProps,
    error,
    isBoolean,
    isRequired,
    isArray,
    currentValue,
    isReadonly,
    setValue,
  };
}

interface UseFormParamsArgs {
  name: string;
}